import cn from 'classnames';
import { IconProps } from 'components/Shared/Icon/index';

interface OwnProps extends IconProps {
  isHalf?: boolean;
  color?: string;
  emptyStarColor?: string;
  gradientId?: string;
}

export const IconStar = (props: OwnProps) => {
  const gradientId = props.gradientId || 'gradient';

  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={cn(props.className)} viewBox="0 0 16 14">
      <linearGradient id={gradientId}>
        <stop offset="50%" stopColor={props.color || '#FFBD27'} />
        <stop offset="51%" stopColor={props.emptyStarColor || '#EBEBEB'} />
      </linearGradient>
      <path
        fill={props.isHalf ? `url(#${gradientId})` : props.color || props.emptyStarColor || ''}
        fillRule="evenodd"
        d="M8 0L5.25505545 4.26300347 0 5.34702587l3.55845474 3.71939184L3.05573675 14 8 12.0352094 12.9442632 14l-.5027179-4.93358229L16 5.34702587l-5.2550554-1.0840224z"
      />
    </svg>
  );
};
